<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark ecd-navbar">
    <router-link to="/">
    <a class="navbar-brand">
      <img :src="require('@/assets/logo.png')" height="50px" />
    </a>
    </router-link>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul v-if="mode == 'Standard'" class="navbar-nav">
        <template class="nav-item active" v-for="route in routes" >
        <li class="nav-item active" 
        v-if="!route.needsAccount || (route.needsAccount && isLoggedIn)" 
        :key="route.title">
          <router-link :to="route.link">
          <a class="nav-link pointer">
            {{route.title}}
            <span class="sr-only">(current)</span>
          </a>
          </router-link>
        </li>
        </template>



        <li v-if="isLoggedIn" class="nav-item active">
          <a class="nav-link pointer" @click="goLogout">
            Logout
            <span class="sr-only">(current)</span>
          </a>
        </li>
        <li v-if="!isLoggedIn">
          <router-link to="/account/login">
            <a class="nav-link pointer" >Login</a>
          </router-link>
        </li>
        <li v-if="!isLoggedIn">
          <router-link to="/account/register">
            <a class="nav-link pointer" >Register</a>
          </router-link>
        </li>
      </ul>
      <ul v-else-if="mode == 'Admin'" class="navbar-nav">
        <li class="nav-item active">
          <router-link to="/admin">
            <a class="nav-link pointer">
              Admin Home
              <span class="sr-only">(current)</span>
            </a>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/admin/services">
            <a class="nav-link pointer">
              Services
              <span class="sr-only">(current)</span>
            </a>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/admin/listings">
            <a class="nav-link pointer">
              Listings
              <span class="sr-only">(current)</span>
            </a>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/admin/users">
            <a class="nav-link pointer">
              Users
              <span class="sr-only">(current)</span>
            </a>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/admin/coupons">
            <a class="nav-link pointer">
              Coupons
              <span class="sr-only">(current)</span>
            </a>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/admin/site-settings">
            <a class="nav-link pointer">
              Site Settings
              <span class="sr-only">(current)</span>
            </a>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/admin/announcements">
            <a class="nav-link pointer">
              Announcements
              <span class="sr-only">(current)</span>
            </a>
          </router-link>
        </li>
        <li class="nav-item">
          <a class="nav-link pointer" @click="goLogout">
            Logout
            <span class="sr-only">(current)</span>
          </a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import Navigator from "@/router/navigator";
import AccountSessionUtils from "@/components/account/AccountSessionUtils"

export default {
  name: "NavigationBar",
  mounted() {
    this.updateLoggedIn()
  },
  data() {
    return {
      isLoggedIn: false,
      accountUtils:AccountSessionUtils,
      router: Navigator,
      routes: [
        {
          title:'Home',
          link:'/',
          needsAccount:false
        },        
        {
          title:'Listings',
          link:'/categories',
          needsAccount:false
        },
        {
          title:'Create Listing',
          link:'/account/listing/create',
          needsAccount:false
        },
        {
          title:'Favorites',
          link:'/account/favorites',
          needsAccount:false
        },{
          title:'My Listings',
          link:'/account/listings',
          needsAccount:true
        },
        {
          title:'My Account',
          link:'/account',
          needsAccount:true
        }
      ]
    };
  },
  props: {
    mode: {
      type: String,
      default: "Standard"
    }
  },
  methods: {
    goLogout: function() {
      this.router.logout(this);
      this.$forceUpdate()
      this.updateLoggedIn()
    },
    home: function() {
      return this.$route.path == '/'
    },
    updateLoggedIn() {
      this.accountUtils.authorize(
      userId => {
        this.isLoggedIn = parseInt(userId) > 0;
      },
      err => {
        this.isLoggedIn = false
      }
    );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #007bff;
}

.navbar {
  background: #007bff !important;
}

.navbar,
a {
  color: white !important;
}

.pointer {
  cursor: pointer;
}

.navbar {
  background-color: #192965 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/NavigationBar.vue